module.exports = __webpack_public_path__ + "files/pad.239f41325c296f58da5411dccbbf6017.pdf";